import { SET_CURRENT_DATA_PV } from '../actions/actionTypes';

const initialState = {
    data: {},
};

export const dataPvReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CURRENT_DATA_PV:
            return {
                ...state,
                data: action.data,
            };

        default:
            return state;
    }
};
